import { render, staticRenderFns } from "./extendFieldDialog.vue?vue&type=template&id=600e54b2&"
import script from "./extendFieldDialog.vue?vue&type=script&lang=js&"
export * from "./extendFieldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports